var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsoSitensoNegCyan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-cef3bdfc-ed6e-4f32-815c-799f1997e50f",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 182 165.4",
    style: {
      enableBackground: "new 0 0 182 165.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#72D4F4;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 145.7,
    cy: 39,
    r: 31.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.5,83.7c-9,1.4-17.8-0.1-25.5-3.6c0.1,0.9,0.1,1.7,0.1,2.6c0,25.1-20.3,45.4-45.4,45.4 s-45.4-20.3-45.4-45.4s20.3-45.4,45.4-45.4c6.8,0,13.1,1.5,18.9,4.2c-0.6-11.4,3.1-22.1,9.8-30.5c-8.9-3.6-18.5-5.6-28.7-5.6 C39,5.3,4.3,40,4.3,82.7s34.6,77.3,77.3,77.3S159,125.4,159,82.7c0-0.2,0-0.4,0-0.5C156.9,82.8,154.7,83.4,152.5,83.7L152.5,83.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsoSitensoNegCyan);
export default __webpack_public_path__ + "static/media/iso-sitenso-negCyan.78d875d972cb3a5015f3540e15e9f039.svg";
export { ForwardRef as ReactComponent };